import ExaminationPortal from './ExaminationPortal';

export default ExaminationPortal;
